export default __webpack_public_path__ + "static/media/ourteamBG.ea57fbab.webp";